export const imageIconStyles = {
  width: '38px',
  height: '38px',
  objectFit: 'cover',
  borderRadius: '3px',
};

const styles = (theme) => ({
  link: {
    color: 'inherit',
    display: 'block',
    textDecoration: 'none',
  },
  listItem: {
    display: 'grid',
    gridTemplateColumns: '45px calc(100% - 80px) 35px',
    padding: '0px 7px',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.colors.whiteDarker}`,
  },
  actionsDisabled: {
    display: 'flex !important',
  },
  dragElement: {
    display: 'none',
    alignItems: 'center',
    columnGap: '5px',
    padding: '5px',
    position: 'absolute',
    top: '-9999px',
    left: '-9999px',
    backgroundColor: '#f4f4f4',
    borderRadius: '4px',
    touchEvent: 'none',
    pointerEvents: 'none',
    zIndex: 999,

    '& > p': {
      margin: 0,
    },

    '& .hoverIn': {
      display: 'none',
    },

    '&.dragged': {
      display: 'flex',
    },
  },
  folderCheckbox: {
    pointerEvents: 'none',
    opacity: 0,
  },
  borderedItem: {
    borderBottom: `1px solid ${theme.colors.whiteDarker}`,
  },
  menuIcon: {
    color: theme.palette.primary.blackLight,
  },
  iconContainer: ({ showRoomsColumn, showEventsColumn }) => ({
    minWidth: 38,
    marginRight: 10,
    textAlign: 'center',
    marginTop: showRoomsColumn || showEventsColumn ? theme.spacing(1) : 0,
  }),
  secondaryText: {
    display: 'flex',
    fontSize: '12px',
    alignItems: 'center',
  },
  secondaryAction: ({ showRoomsColumn, showEventsColumn }) => ({
    // top: 'calc(50% - 25px)',
    // right: 0,
    // transform: 'none',
    position: 'static',
    transform: 'unset',
    paddingRight: '16px',
    marginTop: showRoomsColumn || showEventsColumn ? theme.spacing(1) : 1,
  }),
  lockIcon: {
    width: '1.2rem',
    height: '1.2rem',
    marginLeft: theme.spacing(0.5),
  },
  checkbox: {
    marginRight: 0,
  },
  listItemSecondaryAction: {
    right: 0,
    transform: 'none',
    position: 'static',
    marginLeft: theme.spacing(1),
  },
  primaryText: {
    fontSize: '14px',
    color: '#13142A',
    textDecoration: 'none !important',
    fontWeight: '400',
    gap: '1px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  listItemButton: {
    userSelect: 'none',
    '-webkit-user-select': 'none',
    '-webkit-user-drag': 'none',
    '-webkit-touch-callout': 'none',
  },
  linkText: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    backgroundColor: 'unset',
    textAlign: 'left',
    width: '100%',
    maxWidth: '100%',
    padding: '10px 0',
    border: 'unset',
    cursor: 'pointer',
    overflow: 'hidden',
    userSelect: 'none',
  },
  imageIcon: {
    width: '16px',
    height: '16px',
  },
  imageIconBox: {
    minWidth: '32px',
    height: '32px',
    background: '#F2F8F8',
    borderRadius: '3px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10,
    position: 'relative',
  },
  thumbnailImageIcon: {
    width: '32px',
    height: '32px',
    objectFit: 'cover',
    borderRadius: '3px',
  },
  builidingDocViewContainer: {
    marginTop: '1px',
  },
  lockForDocViewContainer: {
    marginTop: 4,
  },
  systemFolderIcon: {
    position: 'absolute',
    top: '-5px',
    left: '18px',
  },
});

export default styles;
